/**
 * The one place the app asks whether the viewer wants reduced motion.
 *
 * `screenMotion` takes the preference as a REQUIRED parameter — see its header for why it is not a
 * hook call — and that leaves every caller with the same two lines: read the media query, coerce
 * the `null` Motion returns before the query has been read. Written twice, those two lines drift;
 * written once, the coercion cannot be forgotten in a component that only ever ran on a machine
 * with animation on.
 */

import { useReducedMotion } from 'motion/react';

/**
 * `true` when the viewer asked their system for reduced motion.
 *
 * Motion answers `boolean | null`, `null` meaning "the media query has not been read yet". That is
 * treated as "motion is fine", which is the same default the CSS media query has: a preference
 * nobody has expressed is not a preference for stillness.
 */
export function useScreenMotionPreference(): boolean {
  return useReducedMotion() ?? false;
}
